import { makeStyles } from "@material-ui/styles";

const emptyMatchStyles = makeStyles((theme) => ({
	box: {
		margin: theme.spacing(4, 4, 2),
		borderRadius: 4,
		border: "2px dashed rgba(224, 224, 224, 1)",
		borderCollapse: "separate",
		height: 144
	},
	container: {
		paddingBottom: 10
	},
	question: {
		lineHeight: 1
	},
	paperWidthSm: {
		maxWidth: 975,
		width: "100%"
	}
}));

export default emptyMatchStyles;
